import React from 'react';

import { ReactComponent as Icon } from 'assets/img/vectors/organization-switch.svg';

const OrganizationSwitch = ({ fill, ...props }) => (
   <Icon {...props} fill={(fill ? fill : 'rgba(0,0,0,0)')} />
);

export default OrganizationSwitch;
